<template>
    <div class="container">
        <div class="uniform-modal-body">
            <!-- <b-row class="justify-content-center mb-3">
                <h5 class="password-policy-title">{{ labels.title }}</h5> 
            </b-row> -->

            <b-row class="mb-3 align-items-center">
                <b-col cols="1"></b-col>
                <b-col cols="3" class="text-left">
                    <label class="password-policy-item">{{ labels.calificacion }}</label> 
                </b-col>
                <b-col cols="2" class="text-left">
                    <span class="font-weight-bold text-primary">{{ calificacion || '-' }}</span>
                </b-col>
                <b-col cols="6" class="text-left">
                    <label class="password-policy-item">Score</label>
                    <b-form-select
                        v-model="zscore"
                        :options="scoreOptions"
                        class="reset-select"
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled>
                                {{ labels.selectScore }}
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
            </b-row>

            <div v-if="zscore">
                <b-row class="mb-2 align-items-center">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <label class="password-policy-item">{{ labels.tasaUsa }}</label> 
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <b-form-input
                            v-model="TasasByVigencia.tasa_usa"
                            type="number"
                            class="reset-input"
                            :placeholder="labels.tasaUsa"
                            step="0.01"
                        ></b-form-input>
                    </b-col>
                </b-row>

                <b-row class="mb-2 align-items-center">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <label class="password-policy-item">{{ labels.riesgoPais }}</label> 
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <b-form-input
                            v-model="TasasByVigencia.embi"
                            type="number"
                            class="reset-input"
                            :placeholder="labels.riesgoPais"
                            step="0.01"
                        ></b-form-input>
                    </b-col>
                </b-row>

                <b-row class="mb-2 align-items-center">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <label class="password-policy-item">{{ labels.tasaLibreRiesgo }}</label> 
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <b-form-input
                            v-model="TasasByVigencia.tasa_libre_riesgo"
                            type="number"
                            class="reset-input"
                            :placeholder="labels.tasaLibreRiesgo"
                            step="0.01"
                        ></b-form-input>
                    </b-col>
                </b-row>

                <b-row class="mb-2 align-items-center">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <label class="password-policy-item">{{ labels.inflacionUsa }}</label> 
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <b-form-input
                            v-model="TasasByVigencia.inflacion_usa"
                            type="number"
                            class="reset-input"
                            :placeholder="labels.inflacionUsa"
                            step="0.01"
                        ></b-form-input>
                    </b-col>
                </b-row>

                <b-row class="mb-3 align-items-center">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <label class="password-policy-item">{{ labels.inflacionCol }}</label> 
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <b-form-input
                            v-model="TasasByVigencia.inflacion_col"
                            type="number"
                            class="reset-input"
                            :placeholder="labels.inflacionCol"
                            step="0.01"
                        ></b-form-input>
                    </b-col>
                </b-row>

                <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                    <b-button
                        class="reset-btn-primary"
                        @click="guardarClasificacion"
                    >
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>

            <div v-else class="text-center text-muted py-4">
                <span>{{ labels.selectScoreMessage }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import ClasificacionTasas from '../../../services/ClasificacionTasas'; 
import Score from '../../../services/Score'; 
import TipoTasa from "../../../services/TipoTasas" 

export default {
    name: 'Clasificacion',
    props: {
        infoVigencia: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            listTasas: [],
            listTasasScore: [],
            TasasByVigencia: {
                tasa_usa: '',
                embi: '',
                tasa_libre_riesgo: '',
                inflacion_usa: '',
                inflacion_col: '',
                calificacion: '',
                vigencia: '',
                tipo_tasa: ''
            },
            calificacion: '',
            zscore: null,
            fgl_grabar: false,
            fgl_existe: false,
        }
    },
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") { 
                return {
                    title: 'Variables de Calificación',
                    calificacion: 'Calificación',
                    tasaUsa: 'Tasa USA',
                    tasaLibreRiesgo: 'Tasa libre de riesgo',
                    inflacionUsa: 'Inflación USA',
                    inflacionCol: 'Inflación COL',
                    riesgoPais: 'Riesgo país',
                    save: 'Guardar',
                    edit: 'Editar',
                    selectScore: 'Seleccione un Score',
                    selectScoreMessage: 'Seleccione un Score para ver o agregar las variables.'
                }
            } else {
                return {
                    title: 'Classification variables',
                    calificacion: 'Qualification',
                    tasaUsa: 'US Rate',
                    tasaLibreRiesgo: 'Risk free rate',
                    inflacionUsa: 'Inflation USA',
                    inflacionCol: 'Inflation COL',
                    riesgoPais: 'Country risk',
                    save: 'Save',
                    edit: 'Edit',
                    selectScore: 'Select a Score',
                    selectScoreMessage: 'Select a Score to view or add the variables'
                }
            }
        },
        scoreOptions() {
            return this.listTasasScore.map(item => ({
                value: item.tipo_tasa,
                text: item.descripcion
            }));
        }
    },
    methods: {
        guardarClasificacion() {
            this.f_grabe_informacion();
            
            if (!this.fgl_grabar) { 
                this.$toast.error('Campo(s) pendiente(s) por diligenciar'); 
                return;
            }

            const datos = [
                this.TasasByVigencia.tasa_usa, 
                this.TasasByVigencia.tasa_libre_riesgo, 
                this.TasasByVigencia.inflacion_usa, 
                this.TasasByVigencia.inflacion_col, 
                this.TasasByVigencia.embi,
            ];

            if (datos.includes('') || datos.includes(null) || datos.includes(undefined)) { 
                this.$toast.error('Campo(s) pendiente(s) por diligenciar'); 
                return;
            }

            let info = {
                'vigencia': this.infoVigencia, 
                'calificacion': this.calificacion, 
                'tipo_tasa': this.zscore, 
                'tasaUsa': this.TasasByVigencia.tasa_usa, 
                'tasaLibreRiesgo': this.TasasByVigencia.tasa_libre_riesgo, 
                'inflacionUsa': this.TasasByVigencia.inflacion_usa, 
                'inflacionCol': this.TasasByVigencia.inflacion_col, 
                'embi': this.TasasByVigencia.embi,
                'idUser': this.$store.state.userId 
            };

            ClasificacionTasas.createClasificacionTasas(info) 
                .then((res) => { 
                    if (res.status == 201 || res.status == 200) { 
                        this.$toast.success(res.data.message);
                        this.$emit('clasificacion-guardada');
                        this.loadData();
                    }
                })
                .catch((err) => { 
                    this.$toast.error("Problema al grabar Información"); 
                    console.log(err); 
                });
        },
        f_seleccione_variables(tasaZscore) {
            if (!this.zscore) return;

            ClasificacionTasas.getAllClasificacionTasas(
                this.infoVigencia, 
                this.calificacion, 
                tasaZscore
            )
            .then((res) => { 
                this.listTasas = res.data.clasificacionTasa || [];
                this.TasasByVigencia = {
                    tasa_usa: '',
                    embi: '',
                    tasa_libre_riesgo: '',
                    inflacion_usa: '',
                    inflacion_col: '',
                    calificacion: this.calificacion,
                    vigencia: this.infoVigencia,
                    tipo_tasa: this.zscore
                };
                
                if (this.listTasas.length > 0) { 
                    const found = this.listTasas.find(zscore => zscore.tipo_tasa == this.zscore);
                    if (found) {
                        this.TasasByVigencia = { ...this.TasasByVigencia, ...found };
                    } else {
                        this.TasasByVigencia = { ...this.TasasByVigencia, ...this.listTasas[0] };
                        this.TasasByVigencia.tipo_tasa = this.zscore;
                    }
                }
                
                this.f_grabe_informacion(); 
            })
            .catch((error) => console.log(error)); 
        },
        f_grabe_informacion() {
            if (!this.TasasByVigencia) { 
                this.TasasByVigencia = {
                    calificacion: this.calificacion,
                    vigencia: this.infoVigencia,
                    tipo_tasa: this.zscore
                };
            }
            
            this.fgl_grabar = true;
            
            // Validar todos los campos requeridos
            const camposRequeridos = [
                'inflacion_col',
                'inflacion_usa',
                'tasa_libre_riesgo',
                'tasa_usa',
                'embi'
            ];
            
            for (let campo of camposRequeridos) {
                const valor = this.TasasByVigencia[campo];
                if (valor === undefined || valor === null || valor === '' || valor === 0) {
                    this.fgl_grabar = false;
                    break;
                }
            }
        },
        loadData() {
            // Cargar calificación
            Score.getAllScorexByVigencia(this.infoVigencia) 
                .then((res) => { 
                    if (res.data.qryScoreX && res.data.qryScoreX.length > 0) {
                        this.calificacion = res.data.qryScoreX[0].calificacion;
                    }
                })
                .catch((error) => console.log(error));

            // Cargar tipos de tasa
            TipoTasa.leaTasasZScore() 
                .then((res) => { 
                    this.listTasasScore = res.data.listTipoTasas || [];
                })
                .catch((error) => console.log(error));
        },
        resetForm() {
            this.zscore = null;
            this.TasasByVigencia = {
                tasa_usa: '',
                embi: '',
                tasa_libre_riesgo: '',
                inflacion_usa: '',
                inflacion_col: '',
                calificacion: '',
                vigencia: '',
                tipo_tasa: ''
            };
        }
    },
    mounted() {
        this.loadData();
    },
    watch: {
        zscore(valNew){
            this.f_seleccione_variables(valNew)
        },
        infoVigencia: {
            handler() {
                this.loadData();
                this.resetForm();
            }
        }
    }
}
</script>

<style>
/* Estilos consistentes con el componente Crear */
.reset-input {
    width: 100%;
    padding: 0.5rem 0.75rem;
    border: 1px solid #ced4da;
    border-radius: 6px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.reset-input:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.reset-select {
    width: 100%;
    padding: 0.5rem 0.75rem;
    border: 1px solid #ced4da;
    border-radius: 6px;
    background-color: white;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.reset-select:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.password-policy-title {
    font-weight: 600;
    color: #2c3e50;
    font-size: 1.1rem;
    margin-bottom: 0;
}

.password-policy-item {
    font-weight: 500;
    color: #495057;
    font-size: 0.95rem;
    margin-bottom: 0;
}

.uniform-modal-body {
    padding: 0.5rem 0;
}

.reset-dialog-actions {
    gap: 10px;
}

.reset-btn-primary {
    background-color: #007bff;
    border: 1px solid #007bff;
    color: white;
    padding: 0.5rem 1.5rem;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.3s ease;
}

.reset-btn-primary:hover {
    background-color: #0069d9;
    border-color: #0062cc;
    color: white;
}

.reset-btn-secondary {
    background-color: #6c757d;
    border: 1px solid #6c757d;
    color: white;
    padding: 0.5rem 1.5rem;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.3s ease;
}

.reset-btn-secondary:hover {
    background-color: #5a6268;
    border-color: #545b62;
    color: white;
}

.text-primary {
    color: #007bff !important;
}

.font-weight-bold {
    font-weight: 700 !important;
}

@media (max-width: 768px) {
    .reset-dialog-actions {
        flex-direction: column;
    }
    
    .reset-dialog-actions .b-button {
        width: 100%;
        margin: 0.25rem 0 !important;
    }
}
</style>